import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// common cssのインポート **********/
// import './style/bootstrap/bootstrap.css'
// import './style/app/scrollBar.css'
// common jsのインポート **********/
// import './components/common.js'
// jQuery のインポート **********/
import jQuery from 'jquery'
// Vuetify のインポート **********/
import '@mdi/font/css/materialdesignicons.css' // icon
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')
// 以下を追加 **********/
const vuetify = createVuetify({
  components,
  directives
})
const app = createApp(App)
app.use(router)
app.use(vuetify)
app.use(createPinia())
app.mount('#app')
